import React from "react";
import { Box, Chip, Stack, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import { ToolCard } from "./Tools";
import { Text } from "./NewsLetterComp";

const ACCENT = "#1ACBAF";

const truncate = (text, maxLength) => {
  if (!text) return "";
  return text.length > maxLength ? text.substring(0, maxLength) + "..." : text;
};

const BlogCard = ({ slug, image, cardImage, category, title, excerpt, date, readTime, featured }) => {
  const thumbnail = cardImage || image;

  return (
    <ToolCard
      sx={{
        maxWidth: featured ? "100%" : "350px",
        minHeight: featured ? { xs: "auto", sm: "460px" } : "420px",
        width: "100%",
        borderRadius: "16px",
        overflow: "hidden",
        cursor: "pointer",
        alignItems: "stretch",
        "&:hover": {
          background:
            "linear-gradient(142.21deg, rgba(27, 51, 81, 0.5) 19.63%, rgba(67, 144, 238, 0.5) 83.01%)",
        },
      }}
    >
      <Link to={`/blog/${slug}`} style={{ textDecoration: "none", width: "100%" }}>
        <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
          {thumbnail && (
            <Box sx={{ width: "100%", height: featured ? { xs: "220px", sm: "280px" } : "190px" }}>
              <img
                src={thumbnail}
                alt={title}
                style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
              />
            </Box>
          )}

          <Box sx={{ display: "flex", flexDirection: "column", flex: 1, p: 2.5 }}>
            {category && (
              <Box sx={{ mb: 1.5 }}>
                <Chip
                  label={category}
                  size="small"
                  sx={{
                    background: "#FFFFFF14",
                    color: "#1ACBAF",
                    fontFamily: "Raleway",
                    fontWeight: 600,
                    fontSize: "11px",
                  }}
                />
              </Box>
            )}

            <Typography
              sx={{
                fontFamily: "Righteous",
                fontWeight: 400,
                color: "#FFFFFF",
                fontSize: featured ? "22px" : "16px",
                lineHeight: 1.4,
                mb: 1.5,
              }}
            >
              {truncate(title, featured ? 90 : 60)}
            </Typography>

            <Text
              sx={{
                fontWeight: 400,
                fontSize: "13px",
                color: "#C2C2C2",
                lineHeight: 1.6,
                mb: 2,
              }}
            >
              {truncate(excerpt, featured ? 220 : 130)}
            </Text>

            <Box
              sx={{
                marginTop: "auto",
                pt: 1.5,
                borderTop: "1px solid #FFFFFF14",
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "space-between",
                alignItems: "center",
                rowGap: 0.5,
                gap: 1,
              }}
            >
              <Stack direction="row" spacing={1} flexWrap="wrap">
                <Text
                  sx={{
                    fontFamily: "Raleway",
                    fontWeight: 400,
                    fontSize: "12px",
                    color: "#8B8FA3",
                  }}
                >
                  {date}
                </Text>
                {readTime && (
                  <>
                    <Text sx={{ fontSize: "12px", color: "#8B8FA3" }}>·</Text>
                    <Text
                      sx={{
                        fontFamily: "Raleway",
                        fontWeight: 400,
                        fontSize: "12px",
                        color: "#8B8FA3",
                      }}
                    >
                      {readTime}
                    </Text>
                  </>
                )}
              </Stack>

              <Stack direction="row" alignItems="center" spacing={0.5} sx={{ flexShrink: 0, color: ACCENT }}>
                <Text
                  sx={{
                    fontFamily: "Raleway",
                    fontWeight: 700,
                    fontSize: "12px",
                    color: "inherit",
                  }}
                >
                  Read Article
                </Text>
                <ArrowForwardRoundedIcon sx={{ fontSize: "14px" }} />
              </Stack>
            </Box>
          </Box>
        </Box>
      </Link>
    </ToolCard>
  );
};

export default BlogCard;
